module.exports = __webpack_public_path__ + "static/media/canal.f471681e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/canal.jpg
// module id = 785
// module chunks = 0